import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { parseComboBoxValue } from '@/common/helpers/helpers'

import { getMenuItems } from './helpers'

const DeliveryMethodTypeSelector = ({ onChange, value }) => {
  const { t } = useTranslation()

  return (
    <ComboBox
      handleChange={e => onChange(parseComboBoxValue(e.target.value))}
      value={value || []}
      label={t('Tipo de método de devolución')}
      fullWidth
      multiple
      menuItems={getMenuItems(t)}
    />
  )
}

export default DeliveryMethodTypeSelector
